module.exports = __webpack_public_path__ + "static/media/04.4cc49b5f.png";